import FacultyMembersPage from './FacultyMembersPage';

export default FacultyMembersPage;
